/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { withMyTheme } from '../../theme/theme';
import { Instagram, Facebook, WhatsApp } from '@mui/icons-material';
import { openUrl } from '../../util/openUrl';
import { mobileCss } from '../../util/isMobile';
import { tabletCss } from '../../util/isTablet';
import { PHONE_NUMBER } from '../../components/phoneNumber/PhoneNumber';

export const INSTAGRAM_LINK = 'https://www.instagram.com/weddie.site'
export const FACEBOOK_LINK = 'https://www.instagram.com/weddie.site'
// Format phone number for WhatsApp link by removing spaces and special characters
export const WHATSAPP_LINK = `https://wa.me/${PHONE_NUMBER.replace(/\s+/g, '').replace(/[+]/g, '')}`

const SocialMediaIconsStyle = withMyTheme(() => css`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    
    ${mobileCss(`
        justify-content: center;
    `)}

    ${tabletCss(`
        justify-content: center;
    `)}
`);

const SocialIconStyle = (negative: boolean, brownIcons?: boolean) => withMyTheme((theme) => css`
    width: 40px;
    height: 40px;
    background-color: ${negative ? theme.palette.primary.main : theme.palette.primary.contrastText};
    border-radius: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;
    text-decoration: none;
    color: ${negative ? theme.palette.primary.contrastText : brownIcons ? theme.palette.primary.dark : theme.palette.primary.main};
    
    & svg {
        font-size: 20px;
    }
    
    &:hover {
        transform: scale(1.1);
        opacity: 0.8;
    }
`);

export const SocialMediaIcons = ({ negative = false, brownIcons }: { negative?: boolean, booksyIcon?: string, brownIcons?: boolean }) => {
    const handleSocialClick = (url: string) => {
        openUrl(url)
    };

    const iconStyle = SocialIconStyle(negative, brownIcons);

    return (
        <div css={SocialMediaIconsStyle}>
            <a
                css={iconStyle}
                onClick={() => handleSocialClick(INSTAGRAM_LINK)}
                title="Instagram"
            >
                <Instagram />
            </a>
            <a
                css={iconStyle}
                onClick={() => handleSocialClick('https://www.facebook.com/agata.sawicka.makeup')}
                title="Facebook"
            >
                <Facebook />
            </a>
            <a
                css={iconStyle}
                onClick={() => handleSocialClick(WHATSAPP_LINK)}
                title="WhatsApp"
            >
                <WhatsApp />
            </a>
        </div>
    );
};